export enum NetImpactRating {
  AAA = 'AAA',
  AA_PLUS = 'AA+',
  AA = 'AA',
  A_PLUS = 'A+',
  A = 'A',
  BBB = 'BBB',
  BB = 'BB',
  B = 'B',
  CCC = 'CCC',
  CC = 'CC',
  C = 'C',
}

export const orderedNetImpactRatings = [
  NetImpactRating.AAA,
  NetImpactRating.AA_PLUS,
  NetImpactRating.AA,
  NetImpactRating.A_PLUS,
  NetImpactRating.A,
  NetImpactRating.BBB,
  NetImpactRating.BB,
  NetImpactRating.B,
  NetImpactRating.CCC,
  NetImpactRating.CC,
  NetImpactRating.C,
] as const;
